'use strict';

angular.module('internal.exams')
    .controller('InternalExamSession', ['$scope', '$stateParams', function ($scope, $stateParams) {
        $scope.examSessionID = $stateParams.examSessionID;
    }])
    ;